import { useOutletContext, useParams } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import { UploadCertificate } from 'modules/trainings/components/MyTrainings/UploadCertificate'
import type { TrainingsTraining } from 'modules/trainings/pages/Trainings/Revamp/TrainingDetail/Detail/types'

const EmployeesTrainingCertificateUpload = () => {
  const { id } = useParams()
  const { training, employeeAccessId } = useOutletContext<{
    training: TrainingsTraining
    employeeAccessId: string
  }>()
  const { navigation } = useNavigation()

  return (
    <UploadCertificate
      navigateBackTo={navigation.employees.id.training.detail.view.fullPath({
        id: String(id),
        trainingId: training.id,
      })}
      accessId={employeeAccessId}
    />
  )
}

export default EmployeesTrainingCertificateUpload
